import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export default function FooterDealer() {

    return (
        <>
            <Row className="footer">
                <Row>
                    <Col sm={12} className="footer-col footer-first">
                        <Row className="footer-title keep-layout mt-4">
                            <Col sm={12}>
                                <h4>HELP DESK</h4>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col sm={3} className="footer-col footer-first">
                        <div className="footer-top-text footer-text">
                            <p>K-Dealer Assistance</p>
                        </div>
                    </Col>
                    <Col sm={{ span: 3, offset: 1 }} className="footer-col">
                        <div className="footer-top-text footer-text text-center">
                            <p><a className="phone-link" href="tel:+18006262158">800-626-2158</a></p>
                        </div>
                    </Col>
                    <Col sm={{ span: 3, offset: 1 }} className="footer-col">
                        <div className="footer-top-text footer-bottom-text text-right">
                            <p><a className="phone-link" href="mailto:AtYourService@kmc-usa.com">AtYourService@kmc-usa.com</a></p>
                        </div>
                    </Col>
                </Row>
            </Row>
            <Row className="footer-privacy">
                <Col sm={12}>
                    <a href="https://www.kawasaki.com/en-us/about/legal-policies" target="_blank" rel="noreferrer">Your Privacy Rights</a>
                    <a href="https://www.kawasaki.com/en-us/about/legal-policies#caPrivacyRights" target="_blank" rel="noreferrer">CA Privacy Rights</a>
                    <a href="https://www.kawasaki.com/en-us/about/legal-policies#termsConditionsUse" target="_blank" rel="noreferrer">Terms of Use</a>
                </Col>
            </Row>
        </>
    )
}